import styled from "styled-components";

export const PaginationNormalStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  padding: 10px 24px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  .pn_left_col {
    display: flex;
    align-items: center;
    column-gap: 28px;
    color: ${({ theme }) => theme.COLORS.GRAY_32};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    .pn_dropdown_wrap {
      max-width: 30px;
    }
  }
  .pn_right_col {
    display: flex;
    align-items: center;
    column-gap: 8px;
    color: ${({ theme }) => theme.COLORS.GRAY_32};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    .arrow_group {
      display: flex;
      padding: 0 12px;
      cursor: pointer;
      &:active {
        opacity: 0.7;
      }
    }
    .arrow_single {
      padding: 0 12px;
      cursor: pointer;
      &:active {
        opacity: 0.7;
      }
    }
    .pn_dropdown_wrap {
      min-width: 70px;
      cursor: pointer;
      &:active {
        opacity: 0.7;
      }
    }
  }
`;
